import { Component, input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './footer.html',
})
export class Footer {
  readonly currentYear = signal(new Date().getFullYear());
  readonly variant = input<'layout' | 'auth'>('layout');
}
